import { render, staticRenderFns } from "./RemovePopover.vue?vue&type=template&id=35cd7060"
import script from "./RemovePopover.vue?vue&type=script&lang=js"
export * from "./RemovePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports